const emailUnsubscribe = async (email) => {
  try {
    const response = await fetch('/api/emailUnsubscribe', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        email
      })
    });

    const data = await response.json();

    if (!response.ok) {
      console.error('Failed to unsubscribe email', data);
      throw { success: false, message: 'Failed to unsubscribe email', data };
    }

    return { success: true, data };
  } catch (error) {
    console.error('Error unsubscribing email:', error);
    return { success: false, error };
  }
};

export { emailUnsubscribe };
